module.exports = __webpack_public_path__ + "img/continue_find_answer_icon.52c44878.svg";